import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What tools and technologies are commonly used in Data Science?",
    description:
      "Data Science uses tools like Python, SQL, Pandas, NumPy, Matplotlib, Seaborn, and Scikit-Learn for analysis and modeling. Power BI and Tableau support visualization, while TensorFlow, PyTorch, Hadoop, and Spark assist in advanced workflows",
  },
  {
    title: "What are the challenges commonly faced in a Data Science career?",
    
    description:
      "Data Science challenges include handling messy or incomplete data, selecting useful features, choosing suitable models, and aligning work with business needs. Data Scientists must also explain insights clearly, combining technical analysis with effective storytelling for decision-makers.",
  },
  {
    title: "What kind of projects will I work on in the Data Science domain?",
    
    description:
      "Data Science projects focus on solving real-world problems through data analysis. Common examples include sales forecasting, churn prediction, fraud detection, dashboards, recommendation systems, sentiment analysis, and time-series forecasting. These projects strengthen practical problem-solving and analytical skills.",
  },
  {
    title: "How is Data Science different from Artificial Intelligence and Machine Learning?",
    
    description:
      "Data Science involves collecting, cleaning, analyzing, and visualizing data to generate insights. Machine Learning, a subset of Data Science, focuses on prediction using algorithms. AI is broader and aims to create intelligent, human-like systems.",
  },
  {
    title: "What industries are currently using Data Science the most?",
    
    description:
      "Data Science is used in major industries like finance, healthcare, e-commerce, retail, telecom, education, and manufacturing. Companies depend on it for fraud detection, market analysis, predictions, automation, customer insights, and smarter business decision-making.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                <div className="category">{item.category}</div>

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
